import { render } from "./DealerComp.vue?vue&type=template&id=3484eac3&scoped=true"
import script from "./DealerComp.vue?vue&type=script&lang=js"
export * from "./DealerComp.vue?vue&type=script&lang=js"

import "./DealerComp.vue?vue&type=style&index=0&id=3484eac3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3484eac3"]])

export default __exports__